import React, { createContext, useContext, useState } from "react";

const MembershipRegistrationContext = createContext();

export const useMembershipRegistrationContext = () =>
  useContext(MembershipRegistrationContext);

const DEFAULT_FORM_DATA = {
  fullName: "",
  callingName: "",
  nicNumber: "",
  dateOfBirth: "",
  email: "",
  mobileCountryCode: "",
  mobileNumber: "",
  fixedLineCountryCode: "",
  fixedLineNumber: "",
  whatsappCountryCode: "",
  whatsappNumber: "",
  address: "",
  district: "",
  city: null,
  hometown: "",
  abroad: false,
  currentCountry: "",
  industry: "",
  industryOther: "",
  profession: "",
  professionOther: "",
  designation: "",
  designationOther: "",
  employerName: "",
  employerAddress: "",
  officeNumberCountryCode: "",
  officeNumber: "",
  schoolEnrollmentYear: "",
  schoolEnrollmentGrade: "",
  lastPassedYear: "",
  lastPassedGrade: "",
  batch: "",
  advancedLevelStream: "",
  studentEngagements: [
    {
      startYear: "",
      endYear: "",
      designation: "",
    },
  ],
  higherEducation: [
    {
      level: "",
      qualification: "",
      institute: "",
      year: "",
    },
  ],
  donation: {
    donationDate: "",
    donationAmount: "",
    donationReason: "",
  },
  termsAccepted: false,
  portrait: null,
  proofDocument: null,
  paymentSlip: null,
  donationSlip: null,
};

export const MembershipRegistrationProvider = ({ children }) => {
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);

  const [formSection, setFormSection] = useState(0);

  const [captchaValue, setCaptchaValue] = useState(null);

  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [batches, setBatches] = useState([]);

  const resetForm = () => {
    setFormData(DEFAULT_FORM_DATA);
    setFormSection(0);
    setCaptchaValue(null);
  };

  return (
    <MembershipRegistrationContext.Provider
      value={{
        formData,
        setFormData,
        resetForm,
        formSection,
        setFormSection,
        captchaValue,
        setCaptchaValue,
        countries,
        setCountries,
        provinces,
        setProvinces,
        districts,
        setDistricts,
        cities,
        setCities,
        batches,
        setBatches,
      }}
    >
      {children}
    </MembershipRegistrationContext.Provider>
  );
};
